import React, { useEffect, useState } from 'react'
import { Block } from 'notiflix/build/notiflix-block-aio'
import { CirclePicker, ColorResult } from 'react-color'
import DatePicker, { registerLocale } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import tr from 'date-fns/locale/tr'

import { Notify } from 'notiflix/build/notiflix-notify-aio'
import calendarService from '../../services/calendar'

export default function EventTab(props) {
  registerLocale('tr', tr)
  const [isPanelActive, setPanelActive] = useState('')
  const [t_title, setTaskTitle] = useState('')
  const [t_content, setTaskContent] = useState('')
  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())

  const [colors, setColors] = useState(['#cddc39', '#2196f3', '#ff9800', '#f44336'])
  const color_list = { 
    '#cddc39': ['0', 'Düşük'], 
    '#2196f3': ['1', 'Normal'], 
    '#ff9800': ['2', 'Yüksek'], 
    '#f44336': ['3', 'Kritik'] 
  }
  const color_list_reverse = { 
    '0': ['#cddc39', 'Düşük'], 
    '1': ['#2196f3', 'Normal'], 
    '2': ['#ff9800', 'Yüksek'], 
    '3': ['#f44336', 'Kritik'] 
  }
  const [pricolor, setPriColor] = useState('#2196f3')
  const [pritext, setPriText] = useState('Normal')
  const [pricurrent, setPriCurrent] = useState('1')

  function panelClose() {
    setPanelActive('')
    props.setClose()
  }
  async function getEvent() {
    try {
      if (!props.curId || !props.userid) return;
      
      const event = await calendarService.getEventById(props.curId, props.userid);
      if (event) {
        setTaskTitle(event.c_title);
        setTaskContent(event.c_desc);
        setStartDate(calendarService.timestampToDate(event.c_start));
        setEndDate(calendarService.timestampToDate(event.c_end));
        
        // Öncelik ayarları
        const priority = event.c_priority;
        setPriCurrent(priority.toString());
        setPriColor(calendarService.getPriorityColor(priority));
        setPriText(calendarService.getPriorityText(priority));
      }
    } catch (error) {
      console.error('Etkinlik getirilemedi:', error);
      Notify.failure('Etkinlik bilgileri yüklenemedi!');
    }
  }

  useEffect(() => {
    if (props.isActive == true) {
      if (props.curId === '') {
        setStartDate(props.curDate)
        setEndDate(props.curDate)
        setPanelActive('is-active')
      } else {
        getEvent()
        setPanelActive('is-active')
      }
    } else {
      setTaskTitle('')
      setTaskContent('')
      setPriColor('#2196f3')
      setPriCurrent('1')
      setPriText('Normal')
      setStartDate(new Date())
      setEndDate(new Date())
    }
  }, [props.isActive])

  async function addSingleEvent() {
    if (t_title === '' || pricolor === '') return
    
    Block.pulse('.event-tab-container')
    
    try {
      const data = { 
        c_title: t_title, 
        c_desc: t_content, 
        c_priority: parseInt(pricurrent), 
        c_start: calendarService.dateToTimestamp(startDate), 
        c_end: calendarService.dateToTimestamp(endDate) 
      }
      
      const success = await calendarService.createEvent(data, props.userid)

      if (success) {
        props.getAllData()
        Block.remove('.event-tab-container', 100)
        panelClose()
        Notify.success('Etkinlik başarıyla oluşturuldu.')
      } else {
        Notify.failure('Etkinlik oluşturulamadı! Tekrar deneyin.')
        Block.remove('.event-tab-container', 100)
      }
    } catch (error) {
        Notify.failure('Hata oluştu! Tekrar deneyin.')
        Block.remove('.event-tab-container', 100)
      }
  }

  async function updateSingleEvent() {
    if (t_title === '' || pricolor === '') return
    
    Block.pulse('.event-tab-container')
    
    try {
      const data = { 
        id: parseInt(props.curId), 
        c_title: t_title, 
        c_desc: t_content, 
        c_priority: parseInt(pricurrent), 
        c_start: calendarService.dateToTimestamp(startDate), 
        c_end: calendarService.dateToTimestamp(endDate) 
      }
      
      const success = await calendarService.updateEvent(data, props.userid)
      
      if (success) {
        props.getAllData()
        Block.remove('.event-tab-container', 100)
        panelClose()
        Notify.success('Etkinlik başarıyla güncellendi.')
      } else {
        Notify.failure('Etkinlik güncellenemedi! Tekrar deneyin.')
        Block.remove('.event-tab-container', 100)
      }
    } catch (error) {
      console.error('Etkinlik güncelleme hatası:', error)
        Notify.failure('Hata oluştu! Tekrar deneyin.')
        Block.remove('.event-tab-container', 100)
      }
  }

  async function deleteSingleEvent() {
    Block.pulse('.event-tab-container')
    
    try {
      const success = await calendarService.deleteEvent(props.curId, props.userid)
      
      if (success) {
      props.getAllData()
        Block.remove('.event-tab-container', 100)
      panelClose()
        Notify.success('Etkinlik başarıyla silindi.')
    } else {
        Notify.failure('Etkinlik silinemedi! Tekrar deneyin.')
        Block.remove('.event-tab-container', 100)
      }
    } catch (error) {
      console.error('Etkinlik silme hatası:', error)
      Notify.failure('Hata oluştu! Tekrar deneyin.')
        Block.remove('.event-tab-container', 100)
    }
  }

  function hereiscolor(color) {
    setPriText(color_list[color.hex][1])
    setPriColor(color.hex)
    setPriCurrent(color_list[color.hex][0])
  }

  return (
    <div className="event-tab-container">
      <div className="event-tab-header">
        <h3>
          {props.curId === '' ? 'Yeni Etkinlik' : 'Etkinlik Düzenle'}
        </h3>
        <button className="close-btn" onClick={() => panelClose()}>
          ×
        </button>
        </div>

      <div className="event-tab-content">
        <div className="form-section">
          <label className="form-label">
            Etkinlik Başlığı
          </label>
              <input
            type="text"
            className="form-input"
                value={t_title}
            placeholder="Etkinlik başlığını girin..."
            onChange={(e) => setTaskTitle(e.target.value)}
          />
        </div>

        <div className="form-section">
          <label className="form-label">
            Etkinlik Detayı
          </label>
          <textarea
            className="form-textarea"
            value={t_content}
            placeholder="Etkinlik detaylarını girin..."
            onChange={(e) => setTaskContent(e.target.value)}
            rows={4}
          />
            </div>

        <div className="form-row">
          <div className="form-section">
            <label className="form-label">
              Başlangıç Tarihi
            </label>
                <DatePicker
                  showTimeSelect
              dateFormat="dd MMMM yyyy HH:mm"
                  locale="tr"
              className="form-datepicker"
              placeholderText="Başlangıç tarihi seçin"
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                />
            </div>

          <div className="form-section">
            <label className="form-label">
              Bitiş Tarihi
            </label>
                <DatePicker
                  showTimeSelect
              dateFormat="dd MMMM yyyy HH:mm"
                  locale="tr"
              className="form-datepicker"
              placeholderText="Bitiş tarihi seçin"
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                />
              </div>
            </div>

        <div className="form-section">
          <label className="form-label">
            Öncelik Seviyesi
          </label>
          <div className="priority-section">
            <div className="priority-display">
              <div 
                className="priority-badge" 
                style={{ backgroundColor: pricolor }}
              >
                {pritext}
          </div>
              </div>
            <div className="color-picker-container">
              <CirclePicker 
                colors={colors} 
                circleSpacing={12} 
                onChange={(color) => hereiscolor(color)}
                width="100%"
              />
              </div>
            </div>
          </div>

        <div className="form-actions">
          {props.curId === '' ? (
            <button 
              onClick={addSingleEvent} 
              className="btn-primary"
              disabled={!t_title.trim()}
            >
              Etkinlik Oluştur
            </button>
          ) : (
            <div className="action-buttons">
              <button 
                onClick={updateSingleEvent} 
                className="btn-secondary"
                disabled={!t_title.trim()}
              >
                Güncelle
              </button>
              <button 
                onClick={deleteSingleEvent} 
                className="btn-danger"
              >
                Sil
              </button>
            </div>
          )}
              </div>
            </div>

      <style jsx="true">{`
        .event-tab-container {
          background: white;
          border-radius: 12px;
          box-shadow: 0 8px 24px rgba(0,0,0,0.08);
          overflow: hidden;
          animation: fadeIn 0.2s ease-out;
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-4px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .event-tab-header {
          background: #ffffff;
          color: #0f172a;
          padding: 16px 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #e2e8f0;
        }

        .event-tab-header h3 {
          margin: 0;
          font-size: 1.1rem;
          font-weight: 600;
        }

        .close-btn {
          background: transparent;
          border: 1px solid #e2e8f0;
          color: #334155;
          height: 32px;
          padding: 0 12px;
          border-radius: 8px;
          cursor: pointer;
          transition: background 0.2s ease;
        }

        .close-btn:hover {
          background: #f8fafc;
        }

        .event-tab-content {
          padding: 20px;
        }

        .form-section { margin-bottom: 16px; }

        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
        }

        .form-label {
          display: block;
          font-weight: 600;
          color: #334155;
          margin-bottom: 6px;
          font-size: 14px;
        }

        .form-input, .form-textarea {
          width: 100%;
          padding: 10px 12px;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          font-size: 14px;
          transition: border-color 0.2s ease, box-shadow 0.2s ease;
          background: #ffffff;
        }

        .form-input:focus, .form-textarea:focus {
          outline: none;
          border-color: #94a3b8;
          box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.25);
        }

        .form-textarea { resize: vertical; min-height: 80px; }

        .form-datepicker {
          width: 100%;
          padding: 10px 12px;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          font-size: 14px;
          background: #ffffff;
          transition: border-color 0.2s ease, box-shadow 0.2s ease;
        }

        .form-datepicker:focus {
          outline: none;
          border-color: #94a3b8;
          box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.25);
        }

        .priority-section { display: flex; flex-direction: column; gap: 12px; }
        .priority-display { display: flex; justify-content: center; }

        .priority-badge {
          padding: 6px 16px;
          border-radius: 999px;
          color: white;
          font-weight: 600;
          font-size: 13px;
          text-align: center;
          min-width: 100px;
        }

        .color-picker-container { display: flex; justify-content: center; padding: 6px; background: #f8fafc; border-radius: 8px; }

        .form-actions {
          margin-top: 20px;
          padding-top: 16px;
          border-top: 1px solid #e2e8f0;
        }

        .action-buttons { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }

        .btn-primary, .btn-secondary, .btn-danger {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 12px 16px;
          border: 1px solid transparent;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: background 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
          text-decoration: none;
        }

        .btn-primary { background: #0f172a; color: white; width: 100%; }
        .btn-primary:hover:not(:disabled) { background: #111827; }

        .btn-secondary { background: #1f2937; color: white; }
        .btn-secondary:hover:not(:disabled) { background: #111827; }

        .btn-danger { background: #dc2626; color: white; }
        .btn-danger:hover { background: #b91c1c; }

        .btn-primary:disabled, .btn-secondary:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        @media (max-width: 768px) {
          .form-row { grid-template-columns: 1fr; gap: 12px; }
          .action-buttons { grid-template-columns: 1fr; gap: 10px; }
          .event-tab-content { padding: 16px; }
          .event-tab-header { padding: 14px 16px; }
          .event-tab-header h3 { font-size: 1rem; }
        }

        :global(.react-datepicker-wrapper) { width: 100%; }
        :global(.react-datepicker__input-container input) {
          width: 100%;
          padding: 10px 12px;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          font-size: 14px;
          background: #ffffff;
          transition: border-color 0.2s ease, box-shadow 0.2s ease;
        }
        :global(.react-datepicker__input-container input:focus) {
          outline: none;
          border-color: #94a3b8;
          box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.25);
        }
        :global(.react-datepicker) { border: none; box-shadow: 0 6px 18px rgba(0,0,0,0.12); border-radius: 10px; }
        :global(.react-datepicker__header) { background: #0f172a; border: none; border-radius: 10px 10px 0 0; }
        :global(.react-datepicker__current-month) { color: white; font-weight: 600; }
        :global(.react-datepicker__day-name) { color: white; font-weight: 500; }
        :global(.react-datepicker__day--selected) { background: #0f172a; color: white; }
        :global(.react-datepicker__day:hover) { background: rgba(15, 23, 42, 0.15); }

        :global(.circle-picker) { padding: 0 !important; }
        :global(.circle-picker > div) { border: 2px solid white !important; box-shadow: 0 1px 4px rgba(0,0,0,0.12) !important; transition: transform 0.15s ease !important; }
        :global(.circle-picker > div:hover) { transform: scale(1.1) !important; }
      `}</style>
    </div>
  )
}